function isAndroidRuntime() {
  if (typeof window === "undefined") {
    return false;
  }

  return (
    window.location.href.includes("android") &&
    typeof cordova !== "undefined" &&
    typeof cordova.exec === "function"
  );
}

function getAdvancedTtsPlugin() {
  if (typeof window === "undefined") {
    return null;
  }

  return window.TTS && typeof window.TTS.speak === "function"
    ? window.TTS
    : null;
}

function speakByAdvancedTts(text) {
  const plugin = getAdvancedTtsPlugin();
  if (!plugin) {
    return Promise.reject(new Error("TTS advanced plugin is unavailable"));
  }

  return plugin
    .speak({
      text,
      locale: "ja-JP",
      rate: 1,
      pitch: 1,
      cancel: true,
    })
    .then(() => true);
}

function stopByAdvancedTts() {
  const plugin = getAdvancedTtsPlugin();
  if (!plugin || typeof plugin.stop !== "function") {
    return Promise.resolve(false);
  }

  return plugin.stop().then(() => true).catch(() => false);
}

function speakByWebSpeech(text) {
  if (
    typeof window === "undefined" ||
    typeof window.speechSynthesis === "undefined" ||
    typeof SpeechSynthesisUtterance === "undefined"
  ) {
    return Promise.resolve(false);
  }

  return new Promise((resolve) => {
    try {
      const speech = new SpeechSynthesisUtterance(text);
      speech.lang = "ja-JP";
      speech.pitch = 1;
      speech.rate = 1;
      speech.volume = 1;

      window.speechSynthesis.cancel();
      window.speechSynthesis.speak(speech);
      resolve(true);
    } catch (error) {
      console.warn("Web Speech playback failed.", error);
      resolve(false);
    }
  });
}

export async function speakText(text) {
  const normalizedText = String(text || "").trim();

  if (!normalizedText) {
    return false;
  }

  if (isAndroidRuntime()) {
    try {
      return await speakByAdvancedTts(normalizedText);
    } catch (error) {
      console.warn("TTS advanced plugin unavailable on Android.", error);
      return false;
    }
  }

  return speakByWebSpeech(normalizedText);
}

export function stopSpeakText() {
  if (
    typeof window !== "undefined" &&
    typeof window.speechSynthesis !== "undefined"
  ) {
    window.speechSynthesis.cancel();
  }

  if (isAndroidRuntime()) {
    stopByAdvancedTts();
  }
}
